export enum PendingIssueEnum {
  Invalid,
  ClassImage,
  ClassBiography,
  TeacherBiography,
  PendingStudentsProgress
}
